module.exports = __webpack_public_path__ + "static/Abacus HR Clients-9163d5b72142b0d80c108209d31c7d51.png";